import { Restaurant } from '../../services/restaurantService';

export interface OpeningHoursRow {
  day: string;
  breakfast?: string;
  lunch?: string;
  dinner?: string;
}

export function formatFullAddress(restaurant: Restaurant): string {
  const addr = restaurant.restaurantAddressDetails;
  if (!addr) return '';
  const parts = [
    addr.locality,
    addr.area,
    addr.landmark,
    addr.city,
    addr.state,
    addr.pincode ? `– ${addr.pincode}` : undefined,
  ].filter(Boolean);
  return parts.join(', ').replace(/, –/, ' –');
}

export function formatPhone(restaurant: Restaurant): string | null {
  const addr = restaurant.restaurantAddressDetails;
  const phone = addr?.phone1 || addr?.phone2 || addr?.landline;
  return phone?.trim() || null;
}

export function restaurantTelHref(phone: string): string {
  const trimmed = phone.trim();
  const keepPlus = trimmed.startsWith('+');
  const digits = trimmed.replace(/\D/g, '');
  return `tel:${keepPlus ? '+' : ''}${digits}`;
}

export function getDirectionsUrl(restaurant: Restaurant): string | null {
  const addr = restaurant.restaurantAddressDetails;
  if (addr?.googleMapLink) return addr.googleMapLink;
  if (addr?.lat != null && addr?.lng != null) {
    return `https://www.google.com/maps/search/?api=1&query=${addr.lat},${addr.lng}`;
  }
  const full = formatFullAddress(restaurant);
  if (full) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(full)}`;
  }
  return null;
}

/** Open breakfast/lunch/dinner slots for a day, in order; empty when the day is closed. */
export function formatDayHourSlots(hours: OpeningHoursRow): string[] {
  return [hours.breakfast, hours.lunch, hours.dinner]
    .map((s) => s?.trim() || '')
    .filter((s) => s && s.toLowerCase() !== 'closed');
}

export function getTodayDayName(): string {
  return new Date().toLocaleDateString('en-US', { weekday: 'long' });
}

export function cuisineSubtitle(restaurant: Restaurant): string {
  if (restaurant.cuisineList && restaurant.cuisineList.length > 0) {
    return restaurant.cuisineList
      .slice(0, 3)
      .map((c) => c.name)
      .join(' · ');
  }
  return 'Good Food · Great Experience';
}
